import type { SVGProps } from 'react';

const Route = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.5001 12.8334H4.49999C3.76361 12.8334 3.16666 12.2364 3.16666 11.5V4.50002C3.16666 3.76364 3.76361 3.16669 4.49999 3.16669H11.5001C12.2365 3.16669 12.8335 3.76364 12.8335 4.50002V11.5C12.8335 12.2364 12.2365 12.8334 11.5001 12.8334Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.33332 5.5H7.99999C8.82839 5.5 9.49999 6.17157 9.49999 7C9.49999 7.8284 8.82839 8.5 7.99999 8.5H6.16666C5.61437 8.5 5.16666 8.94773 5.16666 9.5C5.16666 10.0523 5.61437 10.5 6.16666 10.5H8.83332C9.56972 10.5 10.1667 11.0969 10.1667 11.8333V12.8333"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.16666 5.5H5.49999"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Route;
